import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import "../components/TelegramModal/_Telegram.custom.scss";
import TelegramModal from '@/components/TelegramModal/TelegramModal';
document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('telegram-modal-root');
    if (!root) {
        throw new Error("Не найден корневой контейнер #telegram-modal-root для размещения REACT-компонента");
    }
    const telegramModalApp = createRoot(root);
    telegramModalApp.render(_jsx(StrictMode, { children: _jsx(TelegramModal, {}) }));
});
